import { Component, inject, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-add-sales-user-coins-dialog',
  templateUrl: './add-sales-user-coins-dialog.component.html',
  styleUrl: './add-sales-user-coins-dialog.component.css',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule
  ]
})
export class AddSalesUserCoinsDialogComponent {
  amount = new FormControl(0, [Validators.required, Validators.min(1)]);
  constructor(
    public dialogRef: MatDialogRef<AddSalesUserCoinsDialogComponent>,
  ) { }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAdd(): void {
    if (this.amount.valid) {
      this.dialogRef.close(this.amount.value);
    }
  }
}
